











import { Component, Vue, Prop } from 'vue-property-decorator';
import { centsToEuro, currency } from '@/filters/currency';
import Fieldset from '@/components/common/Fieldset.vue';
import { SellOffer } from '@/store/sellOffer/types';
import { Asset } from '@/store/asset/types';
import { Wallet } from '@/store/wallet/types';

@Component({
  components: {
    Fieldset,
  },
  filters: {
    centsToEuro,
    currency,
  },
})
export default class WalletDetails extends Vue {
  @Prop({required: true})
  wallet: Wallet;
}
